export const SCHEDULING = 'scheduling';
export const EHR = 'ehr';
export const EHR_ERX = 'ehr_erx';
export const CLAIMS = 'claims';

export const ROLES = {
  administrator: 'administrator',
  provider: 'provider',
  clinical_staff: 'clinical_staff',
  front_desk_staff: 'front_desk_staff',
  biller: 'biller',
};

export const ROLES_PERMISSION = {
  administrator: 'administrator',
  biller: 'biller',
  provider: 'provider',
  clinical_staff: 'clinical_staff',
  front_desk_staff: 'front_desk_staff',
};

export const LICENSES = {
  scheduling: 'scheduling',
  ehr: 'ehr',
  ehr_erx: 'ehr_erx',
  claims: 'claims',
  telehealth: 'telehealth',
  eLabs: 'eLabs',
};

const getRolePermissions = (
  administrator = false,
  biller = false,
  provider = false,
  clinical_staff = false,
  front_desk_staff = false
) => {
  return { administrator, biller, provider, clinical_staff, front_desk_staff };
};

export const ROLE_BASED_PERMISSIONS = {
  dashboard: {
    upcomingAppointmentWidget: getRolePermissions(
      true,
      false,
      true,
      true,
      true
    ),
    completedAppointmentWidget: getRolePermissions(
      true,
      false,
      true,
      true,
      true
    ),
    prescriptionMessagesWidgets: getRolePermissions(
      false,
      false,
      true,
      true,
      false
    ),
    // pendingClaimsWidget: getRolePermissions(true, true, false, false, true),
    pendingClaimsWidget: getRolePermissions(true, true, false, false, false),
    // pendingInvoicesWidget: getRolePermissions(true, true, false, false, true),
    pendingInvoicesWidget: getRolePermissions(true, true, true, true, true),
    createNewAppointmentHyperlink: getRolePermissions(
      true,
      false,
      true,
      true,
      true
    ),
    createNewClaimHyperlink: getRolePermissions(true, true, false, false, true),
    createNewPatientHyperlink: getRolePermissions(true, true, true, true, true),
  },

  organizations: {
    myOrganisation: getRolePermissions(true, true, true, true, true),
    allOrganisations: getRolePermissions(true, true, true, true, true),
  },
  locations: {
    myLocations: getRolePermissions(true, true, true, true, true),
    allLocations: getRolePermissions(true, true, true, true, true),
  },

  practitioners: {
    myPractice: {
      providerMyPractice: getRolePermissions(true, true, true, true, true),
      calendarMyPractice: getRolePermissions(true, false, true, true, true),
      locationsMyPractice: getRolePermissions(true, false, true, true, true),
      feeScheduleMyPractice: getRolePermissions(true, true, true, true, true),
    },
    allPractitioners: {
      providerAllPractitioners: getRolePermissions(
        true,
        true,
        true,
        true,
        true
      ),
      calendarAllPractitioners: getRolePermissions(
        true,
        false,
        true,
        true,
        true
      ),
      locationsAllPractitioners: getRolePermissions(
        true,
        false,
        true,
        true,
        true
      ),
      feeScheduleAllPractitioners: getRolePermissions(
        true,
        true,
        true,
        true,
        true
      ),
    },
  },
  appointments: getRolePermissions(true, false, true, true, true),
  telehealth: getRolePermissions(true, false, true, true, true),
  ehr: {
    patients: getRolePermissions(true, true, true, true, true),
    encounters: getRolePermissions(false, false, true, true, false),
    vitals: getRolePermissions(false, false, true, true, false),
    // coverage: getRolePermissions(false, true, false, true, false),
    coverage: getRolePermissions(true, true, true, true, true),
    allergies: getRolePermissions(false, false, true, true, false),
    // pastMedicalHistory: getRolePermissions(false, false, true, true, false),
    // socialHistory: getRolePermissions(false, false, true, true, false),
    // familyMemberHistory: getRolePermissions(false, false, true, true, false),
    documents: getRolePermissions(true, true, true, true, true),
    forms: getRolePermissions(true, true, true, true, true),
    reports: getRolePermissions(true, true, true, true, true),
    ratingScale: getRolePermissions(false, false, true, true, false),
    serviceRequests: getRolePermissions(false, false, true, true, false),
    lab: getRolePermissions(false, false, true, true, false),
    pharmacyMessages: getRolePermissions(false, false, true, true, false),
    // immunization: getRolePermissions(false, false, true, true, false),
    history: getRolePermissions(true, false, true, false, false),
    tasks: getRolePermissions(true, false, true, false, false),
    implantedDevices: getRolePermissions(true, false, true, false, false),
  },

  // claim: getRolePermissions(true, true, false, false, true),
  claim: getRolePermissions(true, true, false, false, false),

  contacts: getRolePermissions(true, true, true, true, true),

  form: getRolePermissions(true, true, true, true, true),

  reportsTemplates: getRolePermissions(true, true, true, true, true),

  invoice: getRolePermissions(true, true, true, true, true),
  export: getRolePermissions(true, false, false, false, false),
  accounts: {
    profile: getRolePermissions(true, true, true, true, true),

    allUserProfiles: getRolePermissions(true, false, false, false, false),
    practiceSummary: getRolePermissions(true, false, false, false, false),
  },
};

const getLicensePermissions = (
  scheduling = false,
  ehr = false,
  ehr_erx = false,
  claims = false,
  telehealth = false,
  eLabs = false
) => {
  return { scheduling, ehr, ehr_erx, claims, telehealth, eLabs };
};

export const LICENSE_BASED_PERMISSIONS = {
  dashboard: {
    upcomingAppointmentWidget: getLicensePermissions(
      true,
      false,
      false,
      false,
      false
    ),
    completedAppointmentWidget: getLicensePermissions(
      true,
      false,
      false,
      false,
      false
    ),
    prescriptionMessagesWidgets: getLicensePermissions(
      false,
      false,
      true,
      false,
      false
    ),
    pendingClaimsWidget: getLicensePermissions(
      false,
      false,
      false,
      true,
      false
    ),
    pendingInvoicesWidget: getLicensePermissions(
      false,
      true,
      true,
      true,
      false
    ),
    createNewAppointmentHyperlink: getLicensePermissions(
      true,
      false,
      false,
      false,
      false
    ),
    createNewClaimHyperlink: getLicensePermissions(
      false,
      false,
      false,
      true,
      false
    ),
    createNewPatientHyperlink: getLicensePermissions(
      true,
      true,
      true,
      true,
      false
    ),
  },

  organizations: {
    myOrganisation: getLicensePermissions(true, true, true, true, false),
    allOrganisations: getLicensePermissions(true, true, true, true, false),
  },
  locations: {
    myLocations: getLicensePermissions(true, true, true, true, false),
    allLocations: getLicensePermissions(true, true, true, true, false),
  },

  practitioners: {
    myPractice: {
      providerMyPractice: getLicensePermissions(true, true, true, true, false),
      calendarMyPractice: getLicensePermissions(
        true,
        false,
        false,
        false,
        false
      ),
      locationsMyPractice: getLicensePermissions(
        true,
        false,
        false,
        false,
        false
      ),
      feeScheduleMyPractice: getLicensePermissions(
        false,
        false,
        false,
        true,
        false
      ),
    },
    allPractitioners: {
      providerAllPractitioners: getLicensePermissions(
        true,
        true,
        true,
        true,
        false
      ),
      calendarAllPractitioners: getLicensePermissions(
        true,
        false,
        false,
        false,
        false
      ),
      locationsAllPractitioners: getLicensePermissions(
        true,
        false,
        false,
        false,
        false
      ),
      feeScheduleAllPractitioners: getLicensePermissions(
        false,
        false,
        false,
        true,
        false
      ),
    },
  },
  appointments: getLicensePermissions(true, false, false, false, false),
  telehealth: getLicensePermissions(false, false, false, false, true),
  ehr: {
    patients: getLicensePermissions(true, true, true, true, false),
    encounters: getLicensePermissions(false, true, true, false, false),
    vitals: getLicensePermissions(false, true, true, false, false),
    coverage: getLicensePermissions(false, true, true, true, false),
    allergies: getLicensePermissions(false, true, true, false, false),
    // pastMedicalHistory: getLicensePermissions(false, true, true, false, false),
    // socialHistory: getLicensePermissions(false, true, true, false, false),
    // familyMemberHistory: getLicensePermissions(false, true, true, false, false),
    documents: getLicensePermissions(false, true, true, true, false),
    forms: getLicensePermissions(false, true, true, true, false),
    reports: getLicensePermissions(false, true, true, true, false),
    ratingScale: getLicensePermissions(false, true, true, false, false),
    serviceRequests: getLicensePermissions(false, true, true, false, false),
    lab: getLicensePermissions(false, false, false, false, false, true),
    pharmacyMessages: getLicensePermissions(false, true, true, false, false),
    // immunization: getLicensePermissions(false, true, true, false, false),
    history: getLicensePermissions(false, true, true, false, false),
    tasks: getLicensePermissions(false, true, true, false, false),
    implantedDevices: getLicensePermissions(false, true, true, false, false),
  },

  claim: getLicensePermissions(false, false, false, true, false),
  contacts: getLicensePermissions(true, true, true, true, false),

  form: getLicensePermissions(true, true, true, true, false),

  reportsTemplates: getLicensePermissions(true, true, true, true, false),

  invoice: getLicensePermissions(true, true, true, true, false),
  export: getLicensePermissions(false, true, false, false, false),

  accounts: {
    profile: getLicensePermissions(true, true, true, true, false),

    allUserProfiles: getLicensePermissions(true, true, true, true, false),

    practiceSummary: getLicensePermissions(true, true, true, true, false),
  },
};
